import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const GENDER_SCHEMA_FIELD_NAME = "gender";

export const getGenderFormFieldSchema = () =>
  yup.string().trim().required().label(i18n("GenderFormField__GENDER").toLowerCase());
